/**
 * herd
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 0.220.0-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface TagSearchKey { 
    /**
     * The tag type reference code
     */
    tagTypeCode: string;
    /**
     * An optional tag reference code of the parent tag
     */
    parentTagCode?: string;
    /**
     * An optional boolean flag that specifies if parent tag should not be set for the tags that we want to retrieve                
     */
    isParentTagNull?: boolean;
}
